/*
  „Уведоми ме, когато е наличен“ (Klaviyo Back in Stock) – 2026-10-13.
  - Отваря прозорец с имейл, размер (само изчерпаните) и отметка за бюлетин.
  - Записва известие в Klaviyo: client/back-in-stock-subscriptions
    (вариант $shopify:::$default:::<variant_id>).
  - При отметка абонира имейла в „Email List“ (двойно потвърждение).
  - На продуктовата страница бутонът се вижда само когато избраният размер е изчерпан.
*/
(function () {
  if (window.__rbBis) return;
  window.__rbBis = true;

  var COMPANY = 'S5z3dg';
  var LIST_ID = 'QUKsmL';
  var REVISION = '2025-01-15';
  var API = 'https://a.klaviyo.com/client/';

  var T = {
    bg: {
      title: 'Уведоми ме, когато е наличен',
      lead: 'Ще ви изпратим имейл веднага щом избраният размер е отново наличен.',
      size: 'Размер',
      choose: 'Изберете размер',
      email: 'Имейл',
      news: 'Искам да получавам новини и оферти от Roberto',
      submit: 'Уведоми ме',
      sending: 'Изпращане…',
      ok: 'Готово! Ще ви пишем, щом {size} е наличен.',
      okNews: 'Проверете пощата си, за да потвърдите абонамента за бюлетина.',
      errEmail: 'Моля, въведете валиден имейл.',
      errSize: 'Моля, изберете размер.',
      errNet: 'Нещо се обърка. Опитайте отново след малко.',
      close: 'Затвори',
      privacy: 'Използваме имейла ви само за това известие',
      privacyNews: ' и, ако сте отметнали, за бюлетина.',
      policy: 'Политика за поверителност'
    },
    en: {
      title: 'Notify me when available',
      lead: "We'll email you as soon as the selected size is back in stock.",
      size: 'Size',
      choose: 'Choose a size',
      email: 'Email',
      news: 'I want to receive news and offers from Roberto',
      submit: 'Notify me',
      sending: 'Sending…',
      ok: "Done! We'll email you when {size} is available.",
      okNews: 'Please check your inbox to confirm your newsletter subscription.',
      errEmail: 'Please enter a valid email.',
      errSize: 'Please choose a size.',
      errNet: 'Something went wrong. Please try again.',
      close: 'Close',
      privacy: 'We only use your email for this alert',
      privacyNews: ' and, if ticked, for our newsletter.',
      policy: 'Privacy policy'
    }
  };

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var dlg, lastBtn, t;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      });
    }
    return cache[handle];
  }

  function currentVariantId() {
    var input = document.querySelector('product-form input.product-variant-id, form[action*="/cart/add"] input[name="id"]');
    return input ? String(input.value) : null;
  }

  function post(path, body) {
    return fetch(API + path + '?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
      return r;
    });
  }

  function subscribeBis(email, variantId) {
    return post('back-in-stock-subscriptions/', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
        }
      }
    });
  }

  function subscribeNews(email) {
    return post('subscriptions/', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Back in stock form',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    });
  }

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data));
    } catch (e) {}
  }

  function build() {
    dlg = document.createElement('div');
    dlg.className = 'bis-modal';
    dlg.hidden = true;
    dlg.innerHTML =
      '<div class="bis-modal__backdrop" data-bis-close></div>' +
      '<div class="bis-modal__box" role="dialog" aria-modal="true" aria-labelledby="bis-title">' +
      '<button type="button" class="bis-modal__x" data-bis-close aria-label=""></button>' +
      '<h2 class="bis-modal__title" id="bis-title"></h2>' +
      '<p class="bis-modal__product"></p>' +
      '<p class="bis-modal__lead"></p>' +
      '<form class="bis-form" novalidate>' +
      '<label class="bis-field bis-field--size"><span class="bis-label bis-l-size"></span><select name="variant" required></select></label>' +
      '<label class="bis-field"><span class="bis-label bis-l-email"></span><input type="email" name="email" autocomplete="email" required></label>' +
      '<label class="bis-check"><input type="checkbox" name="news"><span class="bis-l-news"></span></label>' +
      '<p class="bis-error" role="alert" hidden></p>' +
      '<button type="submit" class="button button--full-width bis-submit"></button>' +
      '<p class="bis-privacy"></p>' +
      '</form>' +
      '<div class="bis-done" hidden role="status"></div>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-bis-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dlg && !dlg.hidden) close();
    });
    dlg.querySelector('.bis-form').addEventListener('submit', submit);
  }

  function open(btn) {
    if (!dlg) build();
    lastBtn = btn;
    t = T[btn.dataset.bisLang === 'en' ? 'en' : 'bg'];
    var form = dlg.querySelector('.bis-form');
    dlg.querySelector('.bis-modal__x').setAttribute('aria-label', t.close);
    dlg.querySelector('.bis-modal__x').textContent = '×';
    dlg.querySelector('.bis-modal__title').textContent = t.title;
    dlg.querySelector('.bis-modal__product').textContent = btn.dataset.bisTitle || '';
    dlg.querySelector('.bis-modal__lead').textContent = t.lead;
    dlg.querySelector('.bis-l-size').textContent = t.size;
    dlg.querySelector('.bis-l-email').textContent = t.email;
    dlg.querySelector('.bis-l-news').textContent = t.news;
    dlg.querySelector('.bis-submit').textContent = t.submit;
    dlg.querySelector('.bis-privacy').innerHTML =
      esc(t.privacy) + esc(t.privacyNews) + ' <a href="' + root + 'policies/privacy-policy" target="_blank" rel="noopener">' + esc(t.policy) + '</a>';
    form.hidden = false;
    form.reset();
    dlg.querySelector('.bis-done').hidden = true;
    dlg.querySelector('.bis-error').hidden = true;

    var sel = form.elements.variant;
    sel.innerHTML = '<option value="">' + esc(t.choose) + '</option>';
    product(btn.dataset.bisHandle)
      .then(function (p) {
        var soldout = p.variants.filter(function (v) { return !v.available; });
        soldout.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title === 'Default Title' ? p.title : v.title;
          sel.appendChild(o);
        });
        var cur = btn.dataset.bisContext === 'pdp' ? currentVariantId() : null;
        if (cur && soldout.some(function (v) { return String(v.id) === cur; })) sel.value = cur;
        else if (soldout.length === 1) sel.value = soldout[0].id;
        dlg.querySelector('.bis-field--size').hidden = soldout.length === 1 && p.variants.length === 1;
      })
      .catch(function () {});

    dlg.hidden = false;
    document.documentElement.classList.add('bis-lock');
    setTimeout(function () {
      (form.elements.variant.value ? form.elements.email : form.elements.variant).focus();
    }, 50);
    track('bis_open', { product: btn.dataset.bisHandle });
  }

  function close() {
    dlg.hidden = true;
    document.documentElement.classList.remove('bis-lock');
    if (lastBtn) lastBtn.focus();
  }

  function submit(e) {
    e.preventDefault();
    var form = e.target;
    var err = dlg.querySelector('.bis-error');
    var email = form.elements.email.value.trim();
    var vid = form.elements.variant.value;
    var news = form.elements.news.checked;
    err.hidden = true;
    if (!vid) { err.textContent = t.errSize; err.hidden = false; return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = t.errEmail; err.hidden = false; return; }

    var btn = form.querySelector('.bis-submit');
    btn.disabled = true;
    btn.textContent = t.sending;
    var sizeText = form.elements.variant.options[form.elements.variant.selectedIndex].textContent;

    var jobs = [subscribeBis(email, vid)];
    if (news) jobs.push(subscribeNews(email).catch(function () {}));
    Promise.all(jobs)
      .then(function () {
        try { if (window.klaviyo && klaviyo.identify) klaviyo.identify({ email: email }); } catch (x) {}
        form.hidden = true;
        var done = dlg.querySelector('.bis-done');
        done.innerHTML = '<p>' + esc(t.ok.replace('{size}', sizeText)) + '</p>' + (news ? '<p>' + esc(t.okNews) + '</p>' : '') +
          '<button type="button" class="button button--secondary button--full-width" data-bis-close>' + esc(t.close) + '</button>';
        done.hidden = false;
        track('bis_subscribe', { product: lastBtn && lastBtn.dataset.bisHandle, variant: vid, newsletter: news });
      })
      .catch(function () {
        err.textContent = t.errNet;
        err.hidden = false;
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = t.submit;
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bis-open]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open(b);
  });

  // Продуктова страница: показваме бутона само при изчерпан избран размер
  function syncPdp() {
    var b = document.querySelector('.bis-btn--pdp');
    var submitBtn = document.querySelector('product-form button.product-form__submit[name="add"]');
    if (!b || !submitBtn) return;
    b.classList.toggle('bis-btn--hidden', !submitBtn.disabled);
  }
  var sb = document.querySelector('product-form button.product-form__submit[name="add"]');
  if (sb) {
    new MutationObserver(syncPdp).observe(sb.closest('product-form') || sb, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled'] });
    syncPdp();
  }
})();
